module.exports = __webpack_public_path__ + "img/audio-landscape_cn.809ee30.jpg";